import { render } from "./Main.vue?vue&type=template&id=f7935dc6"
const script = {}
script.render = render

export default script